import React, { Component } from 'react'

import Button from 'components/Button'

import s from './BillingCreditCardRow.scss'
import sLay from 'styles/modules/layout.scss'

export default class BillingCreditCardRow extends Component {
  render() {
    const {
      billingAccount: { creditCardLast4Digits, creditCardExpire, ban },
      showBillingAddCreditCardFormModal,
    } = this.props

    if (creditCardLast4Digits) {
      return (
        <div className={s.row}>
          <div className={sLay['hide-xs']} style={{ maxWidth: '110px' }}>
            Credit Card
          </div>
          <div>xxxx-xxxx-xxxx-{creditCardLast4Digits}</div>
          <div style={{ maxWidth: '70px' }}>{creditCardExpire}</div>
          <div>
            <Button
              size="sm"
              color="tertiary"
              onClick={() => showBillingAddCreditCardFormModal({ ban })}
              ghost
            >
              Update
            </Button>
          </div>
        </div>
      )
    }

    return (
      <Button
        size="sm"
        color="tertiary"
        onClick={() => showBillingAddCreditCardFormModal({ ban })}
        ghost
      >
        Add Credit Card
      </Button>
    )
  }
}



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Billing/BillingCreditCardRow/BillingCreditCardRow.jsx